<template>
	<v-skeleton-loader
    :loading="isInfoLoading"
    height="94"
    type="list-item-avatar"
  >
    <!-- Victims limit 1 month -->
    <v-alert
      prominent
      text
      type="info"
    >
      {{ $t("victims.info.limit") }}
    </v-alert>

  	<v-alert
      color="cyan"
      border="left"
      elevation="2"
      colored-border
      icon="mdi-twitter"
    >
      {{ $t("victims.info.youHave") }} <strong>{{victimsCount}}</strong> {{ $t("victims.info.victims") }}

      <!-- Todays victims -->
      <span 
        v-if="lastVictims > 0"
        class="lastVictims"
      >
        <v-icon small color="#00bcd4">fa-history</v-icon> 24 h <strong>({{lastVictims}})</strong>
      </span>

    </v-alert>
	</v-skeleton-loader>
</template>

<style scoped>
  .lastVictims{
    float: right;
    color: #00bcd4;
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VictimsInfo',

  computed: {
    ...mapGetters({
      isInfoLoading: 'victims/isInfoLoading',
      victimsCount: 'victims/getTotalCount',
      lastVictims: 'victims/getTodayCount'
    }),
  },
};
</script>
